import { Link } from "react-router-dom";

export default function BrandIntro() {
  return (
    <section className="py-10 md:py-14">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-6">关于黑料社区</h1>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-10 items-start">
            <div>
              <h2 className="text-lg font-semibold text-foreground-900 mb-4">品牌故事</h2>
              <div className="space-y-4 text-sm md:text-base text-foreground-700 leading-relaxed">
                <p>
                  黑料社区成立于2024年，是一家专注于热点事件追踪与深度分析的新型资讯平台。我们致力于打破信息壁垒，为公众提供真实、全面、有深度的资讯内容。
                </p>
                <p>
                  在信息爆炸的时代，真相往往被淹没在海量噪音之中。我们的使命是：穿透表象，还原真相，守护公众知情权。无论是社会热点、娱乐八卦，还是科技财经，我们都坚持用专业的视角进行深度剖析。
                </p>
                <p>
                  我们的编辑团队由一批资深的调查记者和行业分析师组成，平均从业经验超过8年。我们坚信，每一个热点背后都有值得深挖的真相。
                </p>
              </div>

              <div className="mt-8 grid grid-cols-3 gap-4">
                <div className="text-center p-4 rounded-xl bg-background-100/70">
                  <div className="text-2xl md:text-3xl font-bold text-primary-600">12+</div>
                  <p className="text-xs md:text-sm text-foreground-500 mt-1">资深编辑</p>
                </div>
                <div className="text-center p-4 rounded-xl bg-background-100/70">
                  <div className="text-2xl md:text-3xl font-bold text-accent-600">500+</div>
                  <p className="text-xs md:text-sm text-foreground-500 mt-1">深度文章</p>
                </div>
                <div className="text-center p-4 rounded-xl bg-background-100/70">
                  <div className="text-2xl md:text-3xl font-bold text-primary-600">50万+</div>
                  <p className="text-xs md:text-sm text-foreground-500 mt-1">月活跃读者</p>
                </div>
              </div>
            </div>

            <div className="relative h-64 lg:h-80 rounded-xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20newsroom%20with%20journalists%20working%20on%20laptops%2C%20warm%20lighting%2C%20collaborative%20workspace%2C%20professional%20atmosphere%2C%20clean%20modern%20office%2C%20editorial%20team%20environment&width=800&height=600&seq=about-brand&orientation=landscape"
                alt="黑料社区编辑团队"
                title="黑料社区编辑团队 - 专业新闻采编团队"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}